export default __webpack_public_path__ + "static/media/Strap_Brown.43ad30c5.png";